"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSame = exports.getFilteredOptions = exports.doesSameExist = exports.anyWordMatches = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _listboxUtils = require("../List/_listboxUtils");
// returns true if any word in a sentence (case insensitive) matches the searchString using
// provided matcherMethod.
var anyWordMatches = exports.anyWordMatches = function anyWordMatches(sentence, searchString) {
  var matcherMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'startsWith';
  if (typeof (sentence === null || sentence === void 0 ? void 0 : sentence.split) === 'function') {
    var _words$find;
    var words = sentence.split(/\s/i);
    return (words === null || words === void 0 ? void 0 : words.length) && !!(words !== null && words !== void 0 && (_words$find = (0, _find.default)(words).call(words, function (word) {
      return (0, _listboxUtils.matcherMethodIgnoreCase)(word, searchString, matcherMethod);
    })) !== null && _words$find !== void 0 && _words$find.length);
  }
  return false;
};

// if non-empty string: returns props.options for which
// any word in option.text begins with searchString, case insensitive
//
// if empty search string: returns entire the props.options array
var getFilteredOptions = exports.getFilteredOptions = function getFilteredOptions(_ref) {
  var _searchString$trim;
  var searchString = _ref.searchString,
    options = _ref.options,
    itemText = _ref.itemText,
    _ref$matcherMethod = _ref.matcherMethod,
    matcherMethod = _ref$matcherMethod === void 0 ? 'startsWith' : _ref$matcherMethod;
  if (searchString !== null && searchString !== void 0 && (_searchString$trim = (0, _trim.default)(searchString).call(searchString)) !== null && _searchString$trim !== void 0 && _searchString$trim.length) {
    return options === null || options === void 0 ? void 0 : (0, _filter.default)(options).call(options, function (eachOption) {
      var _searchString$toLower;
      return searchString !== null && searchString !== void 0 && (_searchString$toLower = searchString.toLowerCase().match(/\s/i)) !== null && _searchString$toLower !== void 0 && _searchString$toLower.length // if search string has white space
      ?
      // treat as one word
      (0, _listboxUtils.matcherMethodIgnoreCase)((0, _listboxUtils.reduceOption)(eachOption, itemText), searchString, matcherMethod) :
      // treat as sentence
      anyWordMatches((0, _listboxUtils.reduceOption)(eachOption, itemText), searchString, matcherMethod);
    });
  }
  return options;
};

// return true if 2 combobox options have the same key value.
var isSame = exports.isSame = function isSame(option1, option2, itemKey) {
  return (0, _listboxUtils.reduceOption)(option1, itemKey) === (0, _listboxUtils.reduceOption)(option2, itemKey);
};

// return true if the key of option1 exists in any of the options in the array
var doesSameExist = exports.doesSameExist = function doesSameExist(option1, optionArr, itemKey) {
  var option1Key = (0, _listboxUtils.reduceOption)(option1, itemKey);
  var optionArray = Array.isArray(optionArr) ? optionArr : [optionArr];
  return optionArray.some(function (option) {
    return (0, _listboxUtils.reduceOption)(option, itemKey) === option1Key;
  });
};